(function () {
  'use strict';

  document.querySelectorAll('.rn-calculator').forEach(initCalculator);

  function initCalculator(section) {
    var data = section.dataset;

    /* ── Config from data attributes ── */
    var config = {
      priceMin: parseFloat(data.tankPriceMin) || 7500,
      priceMax: parseFloat(data.tankPriceMax) || 14099,
      interestRate: (parseFloat(data.interestRate) || 11) / 100,
      financingDiscounts: {
        1: 0,
        2: (parseFloat(data.financingDiscount_2) || 5) / 100,
        4: (parseFloat(data.financingDiscount_4) || 10) / 100,
        8: (parseFloat(data.financingDiscount_8) || 10) / 100
      },
      multiDiscounts: [
        (parseFloat(data.multiDiscount_1) || 5) / 100,
        (parseFloat(data.multiDiscount_2) || 10) / 100,
        (parseFloat(data.multiDiscount_3) || 12) / 100,
        (parseFloat(data.multiDiscount_4) || 15) / 100
      ]
    };

    var financingQuantities = [1, 2, 4, 8];

    /* ── State ── */
    var state = {
      financingQtyIndex: 1,
      financingTerm: 24,
      multiTierIndex: 1,
      profitPayment: 1000,
      profitServices: 100,
      profitCost: 150
    };

    /* ── Tabs ── */
    var tabs = section.querySelectorAll('.rn-calculator__tab');
    var panels = section.querySelectorAll('.rn-calculator__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-active'); });
        panels.forEach(function (p) { p.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var target = section.querySelector('[data-panel="' + tab.dataset.tab + '"]');
        if (target) target.classList.add('is-active');
      });
    });

    /* ── Formatting ── */
    function formatCurrency(num) {
      return '$' + Math.round(num).toLocaleString('en-US');
    }

    function updateRangeTrack(input) {
      var min = parseFloat(input.min);
      var max = parseFloat(input.max);
      var val = parseFloat(input.value);
      var pct = ((val - min) / (max - min)) * 100;
      input.style.setProperty('--range-pct', pct + '%');
    }

    function updateRangeLabels(slider, index) {
      var labels = slider.closest('.rn-calculator__slider-wrap').querySelectorAll('.rn-calculator__range-labels button');
      labels.forEach(function (label) {
        label.classList.toggle('is-active', parseInt(label.dataset.value) === index);
      });
    }

    /* ── Clickable label → slider ── */
    function bindLabelClicks() {
      section.querySelectorAll('.rn-calculator__range-labels').forEach(function (labelGroup) {
        var targetAttr = labelGroup.dataset.for;
        var slider = section.querySelector('[data-' + targetAttr + ']');
        if (!slider) return;

        labelGroup.querySelectorAll('button').forEach(function (btn) {
          btn.addEventListener('click', function () {
            slider.value = btn.dataset.value;
            slider.dispatchEvent(new Event('input'));
          });
        });
      });
    }

    /* ═══════════════════════════════
       FINANCING CALCULATOR
       ═══════════════════════════════ */
    var financingSlider = section.querySelector('[data-financing-slider]');
    var financingPriceEl = section.querySelector('[data-financing-price]');
    var financingTermBtns = section.querySelectorAll('[data-financing-terms] .rn-calculator__term-btn');

    function calcFinancing() {
      if (!financingPriceEl) return;

      var qty = financingQuantities[state.financingQtyIndex];
      var discount = config.financingDiscounts[qty] || 0;
      var term = state.financingTerm;

      var minPrice = config.priceMin * (1 - discount) * qty * (1 + config.interestRate);
      var maxPrice = config.priceMax * (1 - discount) * qty * (1 + config.interestRate);

      var monthlyMin = minPrice / term;
      var monthlyMax = maxPrice / term;

      financingPriceEl.textContent = formatCurrency(monthlyMin) + ' - ' + formatCurrency(monthlyMax);
    }

    if (financingSlider) {
      updateRangeTrack(financingSlider);
      updateRangeLabels(financingSlider, state.financingQtyIndex);

      financingSlider.addEventListener('input', function () {
        state.financingQtyIndex = parseInt(this.value);
        updateRangeTrack(this);
        updateRangeLabels(this, state.financingQtyIndex);
        calcFinancing();
      });
    }

    financingTermBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        financingTermBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        state.financingTerm = parseInt(btn.dataset.term);
        calcFinancing();
      });
    });

    /* ═══════════════════════════════
       MULTI-UNITS CALCULATOR
       ═══════════════════════════════ */
    var multiSlider = section.querySelector('[data-multi-slider]');
    var multiPriceEl = section.querySelector('[data-multi-price]');
    var multiDiscountEl = section.querySelector('[data-multi-discount-display]');

    function calcMultiUnits() {
      if (!multiPriceEl) return;

      var discountPct = config.multiDiscounts[state.multiTierIndex];

      var minPrice = config.priceMin * (1 - discountPct);
      var maxPrice = config.priceMax * (1 - discountPct);

      multiPriceEl.textContent = formatCurrency(minPrice) + ' - ' + formatCurrency(maxPrice);

      if (multiDiscountEl) {
        multiDiscountEl.textContent = Math.round(discountPct * 100) + '% discount';
      }
    }

    if (multiSlider) {
      updateRangeTrack(multiSlider);
      updateRangeLabels(multiSlider, state.multiTierIndex);

      multiSlider.addEventListener('input', function () {
        state.multiTierIndex = parseInt(this.value);
        updateRangeTrack(this);
        updateRangeLabels(this, state.multiTierIndex);
        calcMultiUnits();
      });
    }

    /* ═══════════════════════════════
       PROFIT POTENTIAL CALCULATOR
       ═══════════════════════════════ */
    var profitPriceEl = section.querySelector('[data-profit-price]');
    var profitPayment = section.querySelector('[data-profit-payment]');
    var profitServices = section.querySelector('[data-profit-services]');
    var profitCost = section.querySelector('[data-profit-cost]');

    function calcProfit() {
      if (!profitPriceEl) return;

      var income = (state.profitServices * state.profitCost) - state.profitPayment;
      profitPriceEl.textContent = formatCurrency(Math.max(0, income));
    }

    function bindProfitInput(el, key) {
      if (!el) return;
      el.addEventListener('input', function () {
        state[key] = parseFloat(this.value) || 0;
        calcProfit();
      });
    }

    bindProfitInput(profitPayment, 'profitPayment');
    bindProfitInput(profitServices, 'profitServices');
    bindProfitInput(profitCost, 'profitCost');

    /* ── Label clicks ── */
    bindLabelClicks();

    /* ── Initial calculations ── */
    calcFinancing();
    calcMultiUnits();
    calcProfit();
  }
})();